import PropTypes from "prop-types"
import React, { Component } from "react"
import Relay from "react-relay"
import classNames from "classnames"
import LoadMoreLink from "../elements/LoadMoreLink"
import Masonry from "../elements/Masonry"
import { Link } from "react-router"
import SearchDisplayTools from "../modules/SearchDisplayTools"
import State from "../../stores/State"
import SetResult from "../modules/SetResult"
import { width } from "../../scripts/size"
import { dispatch } from "../../Dispatcher"
import { setArticleStyle } from "../../actions"
import { SET_ARTICLE_STYLES, MOBILE_ARTICLE_STYLE_ID } from "../../constants"
import { default as sharedMessages } from "../../messages/index"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { FormattedMessage } from "react-intl";

class PublicSets extends Component {
  state = {
    articleStyle: State.get("articleStyle"),
    articleStyles: SET_ARTICLE_STYLES
  }

  componentDidMount() {
    this.handleArticleStyles()
    this._stateListener = State.addListener(() => {
      const articleStyle = State.get("articleStyle")
      if (articleStyle !== this.state.articleStyle) {
        this.setState({ articleStyle })
      }
    })
    window.addEventListener("resize", this.handleArticleStyles)
  }

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
    window.removeEventListener("resize", this.handleArticleStyles)
  }

  handleArticleStyles = () => {
    if (width() <= 512) {
      this.setState({ articleStyle: MOBILE_ARTICLE_STYLE_ID })
      dispatch(setArticleStyle(MOBILE_ARTICLE_STYLE_ID))
    }
  }

  render() {
    const { articleStyle, articleStyles } = this.state

    const {
      query: {
        sets: {
          edges: sets,
          pageInfo: { hasNextPage }
        }
      }
    } = this.props

    const results =
      sets.map(({ node: set }) => (
        <SetResult
          key={set.id}
          userSet={set}
          withEdit={false}
          linkTo={`/sets/${set.id}`}
        />
      )) || []

    return (
      <main id="main" role="main" tabIndex={0}>
        {getStyleTag([
          "rich-page-header__content",
          "c-tabs__tab",
          "c-tabs--pagey__tab"
        ])}
        <div
          className="rich-page-header state-has-overlap"
          style={getStyles("rich-page-header")}
        >
          <div
            className="rich-page-header__content mbm"
            style={getStyles("rich-page-header__content")}
          >
            <div className="row column">
              <h1
                className="rich-page-header__title"
                style={getStyles("rich-page-header__title")}
              >
                Community Sets
              </h1>
            </div>
          </div>
        </div>

        <div className={classNames("row column c-tabs c-tabs--pagey")}>
          <nav className="c-tabs__nav">
            <Link
              to="/featured-collections"
              className="c-tabs__tab"
              activeClassName="state-active"
              style={getStyles([
                'c-tabs__tab',
                'collections__c-tabs__tab',
                'sets__c-tabs__tab'
              ])}
            >
              <FormattedMessage {...sharedMessages.featuredCollections} />
            </Link>
            <Link
              to="/collections"
              className="c-tabs__tab"
              activeClassName="state-active"
              style={getStyles(["c-tabs__tab", "sets__c-tabs__tab"])}
            >
              Collections
            </Link>
            <Link
              to="/sets"
              className="c-tabs__tab"
              activeClassName="state-active"
              style={getStyles([
                "c-tabs__tab",
                "sets__c-tabs__tab",
                "c-tabs__tab__active"
              ])}
            >
              Community Sets
            </Link>
          </nav>

          {getStyleTag([
            "search-results__tools",
            "sets__tools__row",
            "search-results__listings",
            "sets__listings"
          ])}

          <div
            className="c-tabs__content state-active"
            style={getStyles("c-tabs__content")}
          >
            <div className="search-results__tools search-results__tools--inpage">
              <div className="column row" style={getStyles("sets__tools__row")}>
                <div className="search-results__tools-inner">
                  <div
                    className="c-results-panel search-results__panel search-results__panel--full"
                    style={getStyles("sets__tools")}
                  >
                    <SearchDisplayTools
                      articleStyles={articleStyles}
                      withSort={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="column row">
              <section
                className="search-results__listings"
                style={getStyles("search-results__listings")}
                data-article-style={articleStyle}
              >
                {results.length > 0 && (
                  <div>
                    {articleStyle === "fluid" ? (
                      <Masonry elementType="div">{results}</Masonry>
                    ) : (
                      results
                    )}
                  </div>
                )}
                {hasNextPage && (
                  <LoadMoreLink onClick={this._handleLoadMore}>
                    Load More Items
                  </LoadMoreLink>
                )}
              </section>
            </div>
          </div>
        </div>
      </main>
    )
  }

  handleLoadMore = () => {
    console.log("TODO")
  }
}

PublicSets.propTypes = {
  query: PropTypes.shape({
    sets: PropTypes.shape({
      edges: PropTypes.array.isRequired,
      pageInfo: PropTypes.shape({
        hasNextPage: PropTypes.bool.isRequired
      })
    })
  }).isRequired
}

export default Relay.createContainer(PublicSets, {
  initialVariables: {
    first: 100
  },

  fragments: {
    query: () => Relay.QL`
      fragment on Query {
        sets: user_sets(first: $first) {
          edges {
            node {
              id
              ${SetResult.getFragment("userSet")}
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/PublicSets.js